import { get } from './sp-api.service';
import { PolicyModel, PortalConfig } from '../models/policy.model';
import { JsonObject } from '../helpers';

export const getUserPolicy = async (): Promise<PolicyModel> => {
  const [policyData, userPortalConfig] = await Promise.all([
    get('/policies/computed'),
    getUserPortalConfig(),
  ]);

  const userPolicy = new PolicyModel((policyData || {}) as JsonObject);

  if (userPortalConfig?.historyEnabled) {
    userPolicy.portal.historyEnabled = true;
  }
  return userPolicy;
};

const getUserPortalConfig = async (): Promise<PortalConfig | null> => {
  const response = (await get(`/policy/portal`)) as { portal: JsonObject };
  return new PortalConfig(response?.portal || {});
};
